module.exports = {
    drsf_force: "Vynútené použitie tohto DRSF",
    lora_boot_msg: "Po spustení zariadenia sa pošle správa prostrednictvom LoRa technólogie",
    lora_on_wifi_connect: "Po pripojení k sieti WiFi bude zariadenie odosielať správy na LoRa",
    cumulative_current: "Kumulatívny prúd",
    cumulative_active_power: "Kumulatívny činný výkon",
    cumulative_reactive_power: "Kumulatívny jalový výkon",
    cumulative_apparent_power: "Kumulatívny zdanlivý výkon",
    cumulative_energy_import: "Kumulatívna energia (odber)",
    cumulative_energy_export: "Kumulatívny energia (dodávka)",
    average_of_average_voltages: "Priemer priemerných napätí",
    cumulative_average_current: "Kumulatívny priemerný prúd",
    cumulative_average_active_power: "Kumulatívny priemerný činný výkon",
    reactive_energy: "Jalová energia",
    quadrant: "kvadrant",
    overall_reactive_energy_import: "Celkový odber reaktívnej energie",
    overall_reactive_energy_export: "Celková dodávka reaktívnej energie",
    time_scaler: "Časová škála",
    power_scaler: "Výkonová škála",
    lora_rssi: "Indikátor sily prijatého signálu LoRa",
    wifi_rssi: "Indikátor sily prijatého signálu WiFi",
    applications: "Aplikácie",
    devices: "Zariadenia",
    settings: "Nastavenia",
    power_on: "Zapnuté",
    power_off: "Vypnuté",
    visible: "Viditeľný",
    invisible: "Neviditeľný",
    cumulative: "Kumulatív"
}